import { render, staticRenderFns } from "./SntSelectReseller.vue?vue&type=template&id=8a95d756&"
import script from "./SntSelectReseller.vue?vue&type=script&lang=js&"
export * from "./SntSelectReseller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports